const CopyIcon = ({ className = "text-[#555] dark:text-[#FAFAFA]" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden
    className={className}
  >
    <path
      d="M6 11.9997C5.63333 11.9997 5.31956 11.8692 5.05867 11.6083C4.79778 11.3475 4.66711 11.0335 4.66667 10.6663V2.66634C4.66667 2.29967 4.79733 1.9859 5.05867 1.72501C5.32 1.46412 5.63378 1.33345 6 1.33301H12C12.3667 1.33301 12.6807 1.46367 12.942 1.72501C13.2033 1.98634 13.3338 2.30012 13.3333 2.66634V10.6663C13.3333 11.033 13.2029 11.347 12.942 11.6083C12.6811 11.8697 12.3671 12.0001 12 11.9997H6ZM6 10.6663H12V2.66634H6V10.6663ZM3.33333 14.6663C2.96667 14.6663 2.65289 14.5359 2.392 14.275C2.13111 14.0141 2.00044 13.7001 2 13.333V4.66634C2 4.47745 2.064 4.31923 2.192 4.19167C2.32 4.06412 2.47822 4.00012 2.66667 3.99967C2.85511 3.99923 3.01356 4.06323 3.142 4.19167C3.27044 4.32012 3.33422 4.47834 3.33333 4.66634V13.333H10C10.1889 13.333 10.3473 13.397 10.4753 13.525C10.6033 13.653 10.6671 13.8112 10.6667 13.9997C10.6662 14.1881 10.6022 14.3466 10.4747 14.475C10.3471 14.6035 10.1889 14.6672 10 14.6663H3.33333Z"
      fill="currentColor"
    />
  </svg>
);

export default CopyIcon;
